module.exports = __webpack_public_path__ + "img/product-camera.e74168b3.jpg";